import { newCondition } from "@/components/match/design-codec";
import { DEFAULT_TEAM_PROFILE_ELEMENT_WEIGHTS, DEFAULT_TEAM_PROFILE_ID } from "@/components/match/match-design-rules";
import { describesRole } from "@/components/match/match-mode";
import type { MatchData } from "@/components/match/match-design-types";
import { toStoragePercent } from "@/lib/skill-levels";
import type { ToMatchMode } from "./dashboard-kinds";
import type { ProjectRequirements } from "./project-plan";

/** The same source conversion for initial matches and later requirements versions. */
export function requirementsToMatchData(requirements: ProjectRequirements, mode: ToMatchMode): Pick<MatchData, "conditions" | "teamProfile"> {
  return {
    conditions: requirements.expertise.map((r) => newCondition("ExpertiseCondition", {
      expertise: r.description,
      level: r.level === 0 ? 0 : toStoragePercent(r.level),
      requirement: r.requirement,
      aiMode: "NO_AI",
      operator: "GE",
      ...(!describesRole(mode) ? { composition: { operator: "MIN" as const, value: r.personCount ?? 1 } } : {}),
    })),
    teamProfile: {
      id: DEFAULT_TEAM_PROFILE_ID,
      name: "",
      elementWeights: Object.keys(requirements.elementWeights).length
        ? requirements.elementWeights : { ...DEFAULT_TEAM_PROFILE_ELEMENT_WEIGHTS },
    },
  };
}
